module.exports = __webpack_public_path__ + "img/logo.5417eff8.png";